import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import api from "../../api/Api.js";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const AddCountryPage = () => {

  // =========================
  // NAVIGATE
  // =========================

  const navigate = useNavigate();
const [loadCountrys, setCountrys] = useState([]);
const [loadCitty, setCitty] = useState([]);

  // =========================
  // STATE
  // =========================
  useEffect(() => {
    fetchCountryData();
    fetchCityData();
  }, []);

  const fetchCountryData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/loadCountryData");
      setCountrys(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };
  
  const fetchCityData = async () => {
    try {
      const res = await api.get("/adminVisaAssistanc/loadCityData");
      setCitty(res.data?.data || []);
    } catch (error) {
      toast.error("Failed to load Country data");
    }
  };

const [countryRows, setCountryRows] = useState([
  {
    country: "",
    city: "",
    slug: "",
  },
]);

  const [addedBy, setaddedBy] = useState("");

  // =========================
  // ADD ROW
  // =========================

const addCountryRow = () => {
  setCountryRows([
    ...countryRows,
    {
      country: "",
      city: "",
      slug: "",
    },
  ]);
};

  // =========================
  // REMOVE ROW
  // =========================

  const removeCountryRow = async (index) => {
  if (countryRows.length === 1) {
    toast.error("At least one row required");
    return;
  }

  const confirm = await Swal.fire({
    title: "Delete Row?",
    icon: "warning",
    showCancelButton: true,
  });

  if (!confirm.isConfirmed) return;

  setCountryRows(countryRows.filter((_, i) => i !== index));
};

  // =========================
  // HANDLE INPUT CHANGE
  // =========================
const handleRowChange = (index, field, value) => {
  const updatedRows = [...countryRows];

  updatedRows[index][field] = value;

  const country = updatedRows[index].country;
  const city = updatedRows[index].city;

  updatedRows[index].slug =
    country && city
      ? `${country}-assistance-in-${city}`
      : "";

  setCountryRows(updatedRows);
};

  // =========================
  // SAVE Country
  // =========================

  const saveCountry = async () => {

    const hasEmpty = countryRows.some(
      (row) => !row.country
    );

    if (hasEmpty) {
      toast.error("Country Name is required");
      return;
    }

    const confirm = await Swal.fire({
      title: "Save Country City Name?",
      text: "Do you want to save this?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes Save"
    });

    if (!confirm.isConfirmed) return;

    try {

      const payload = {
  countryCityData: countryRows,
};

      // API
      const res = await api.post(
        "/adminVisaAssistanc/saveCountryCityName",
        payload
      );

      // SUCCESS
      if (res.data.success) {

        Swal.fire(
          "Success",
          "Country City Name Saved Successfully",
          "success"
        );

        // RESET
        setCountryRows([
          {
            countryName: "",
            slug: ""
          }
        ]);

        // NAVIGATE
        navigate("/country-city/manage-country-city-name");

      } else {

        Swal.fire(
          "Error",
          res.data.message,
          "error"
        );

      }

    } catch (error) {

      // console.log(error);
  // console.log("FULL ERROR =>", error);
  // console.log("RESPONSE DATA =>", error?.response?.data);

  toast.error(error?.response?.data?.message || "Server Error");
      toast.error("Server Error");

    }

  };



  const hendelCountryCityLink= async() =>{

const getLink = `${selectedCountry}-assistance-in-${selectCity}`;

setLinkUrl(getLink);
  }
  // =========================
  // JSX
  // =========================

  return (

    <div className="container-fluid py-3 bg-white min-vh-100">

      {/* HEADER */}

      <div className="card shadow-sm border-0 mb-4 bg-primary-subtle rounded-3">

        <div className="card-body d-flex justify-content-between align-items-center">

          <h4 className="fw-bold mb-0">
            Add Country City Name
          </h4>

          <Link
            to="/country-city/manage-country-city-name"
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-2"
          >
            <ArrowLeft size={16} />
            Back
          </Link>

        </div>

      </div>

      <div className="row">

        {/* TABLE */}

        <div className="col-lg-12">

          <div className="card shadow-sm border-0">

            <div className="card-body">

              <table className="table table-hover table-bordered align-middle mb-0">

                <thead className="table-light">

                  <tr>

                    <th width="50">
                      Sl.No
                    </th>

                    <th>
                      Country Name
                    </th>

                     <th>
                      City Name
                    </th>

                    <th>
                      Slug
                    </th>

                    <th width="120">
                      Action
                    </th>

                  </tr>

                </thead>

             <tbody>
  {countryRows.map((row, index) => (
    <tr key={index}>
      <td>{index + 1}</td>

      <td>
        <select
          className="form-control"
          value={row.country}
          onChange={(e) =>
            handleRowChange(
              index,
              "country",
              e.target.value
            )
          }
        >
          <option value="">
            -- Select Country --
          </option>

          {loadCountrys.map((cat) => (
            <option
              key={cat.cntry_id}
              value={cat.slug}
            >
              {cat.name}
            </option>
          ))}
        </select>
      </td>

      <td>
        <select
          className="form-control"
          value={row.city}
          onChange={(e) =>
            handleRowChange(
              index,
              "city",
              e.target.value
            )
          }
        >
          <option value="">
            -- Select City --
          </option>

          {loadCitty.map((cit) => (
            <option
              key={cit.city_id}
              value={cit.slug}
            >
              {cit.name}
            </option>
          ))}
        </select>
      </td>

      <td>
        <input
          type="text"
          className="form-control"
          value={row.slug}
          readOnly
        />
      </td>

      <td>
        <button
          type="button"
          className="btn btn-success btn-sm me-2"
          onClick={addCountryRow}
        >
          <i className="fa fa-plus-square"></i>
        </button>

        <button
          type="button"
          className="btn btn-danger btn-sm"
          onClick={() =>
            removeCountryRow(index)
          }
        >
          <i className="fa fa-trash"></i>
        </button>
      </td>
    </tr>
  ))}
</tbody>

              </table>

            </div>

          </div>

        </div>

        {/* SAVE BUTTON */}

        <div className="col-lg-12 text-center">

          <button
            className="btn btn-info text-white px-5 mt-3"
            onClick={saveCountry}
          >
            Save Country City Name
          </button>

        </div>

      </div>

    </div>

  );

};

export default AddCountryPage;